export const iconFontAwesomeLogisticsBoxesStacked = (
	<i className="fa-solid fa-boxes-stacked"></i>
);
